"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureExpProjectsPropsSchema = exports.FeatureExpProjectsWithPaginationSchema = exports.FeatureExpProjectPatchSchema = exports.FeatureExpProjectCreationSchema = exports.FeatureExpOneProjectSchema = exports.FeatureExpProjectsSchema = exports.FeatureExpProjectSchemaBase = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const campaign_1 = require("../campaign");
const environment_1 = require("../environment");
const CampaignsPerStatusSchema = zod_1.z
    .object(campaign_1.FeatureExpStatusSchema.options.reduce((acc, status) => {
    acc[status] = zod_1.z.number();
    return acc;
}, {}))
    .extend({
    deleted: zod_1.z.number(),
});
const RoleSchema = zod_1.z.enum(['ADMIN', 'USER', 'VIEWER']);
const AccountEnvironmentSchema = environment_1.FeatureExpEnvironmentTypeSchema.pick({ id: true, environment: true });
const UserSchema = zod_1.z.object({
    id: zod_1.z.string(),
    email: zod_1.z.string().email(),
    firstName: zod_1.z.string().nullable(),
    lastName: zod_1.z.string().nullable(),
});
const TeamProjectRightsSchema = zod_1.z.array(zod_1.z.object({
    id: zod_1.z.string(),
    role: RoleSchema,
    team: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        users: zod_1.z.array(UserSchema),
    }),
    account_environment: AccountEnvironmentSchema,
}));
const UserProjectRightsSchema = zod_1.z.array(zod_1.z.object({
    role: RoleSchema,
    account_environment: AccountEnvironmentSchema,
    user: UserSchema,
}));
exports.FeatureExpProjectSchemaBase = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable().optional(),
    emoji: zod_1.z.string().nullable().optional(),
    access_per_environment: zod_1.z.record(zod_1.z.boolean()),
    created_by_user: UserSchema.nullable(),
});
exports.FeatureExpProjectsSchema = exports.FeatureExpProjectSchemaBase.extend({
    campaigns_per_status: CampaignsPerStatusSchema,
    members_count: zod_1.z.number(),
});
exports.FeatureExpOneProjectSchema = exports.FeatureExpProjectSchemaBase.extend({
    team_project_rights: TeamProjectRightsSchema,
    project_rights: UserProjectRightsSchema,
    campaigns_per_status: CampaignsPerStatusSchema,
});
exports.FeatureExpProjectCreationSchema = exports.FeatureExpProjectSchemaBase.pick({
    name: true,
    description: true,
    emoji: true,
});
exports.FeatureExpProjectPatchSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    id: zod_1.z.string(),
    payload: exports.FeatureExpProjectCreationSchema,
});
exports.FeatureExpProjectsWithPaginationSchema = schemas_1.FeatureExpPaginationSchema.extend({
    items: zod_1.z.array(exports.FeatureExpProjectsSchema),
});
exports.FeatureExpProjectsPropsSchema = schemas_1.FeatureExpPaginationQueryParamSchema.and(zod_1.z.object({
    accountId: zod_1.z.string(),
    search: zod_1.z
        .object({
        name: zod_1.z.string().optional(),
        type: zod_1.z.string().optional(),
    })
        .optional(),
}));
//# sourceMappingURL=schemas.js.map